import classNames from 'classnames';
import React, { FC, PropsWithChildren } from 'react';

import styles from '../Button/Button.styles.m.css';
import { TButtonRounding, TButtonSize, TButtonTheme } from '../Button/Button.types';

interface IExternalLinkProps {
  className?: string;
  href: string;
  size?: TButtonSize;
  rounding?: TButtonRounding;
  theme?: TButtonTheme;
  target?: '_blank' | '_self';
}

export const ExternalLink: FC<PropsWithChildren<IExternalLinkProps>> = ({
  className,
  href,
  size = '10',
  rounding = '0',
  theme = 'primary',
  target = '_blank',
  children,
}) => {
  const classList = classNames(
    styles.container,
    styles[size],
    styles[`rounding-${rounding}`],
    styles[`theme-${theme}`],
    className
  );

  return (
    <a
      className={classList}
      href={href}
      target={target}
    >
      {children}
    </a>
  );
};
